import http from 'conversations-http/clients/http';
export const fetchBillingLimitData = () => {
  return http.get('short-messages/app/v1/limit/sms-inbound-outbound');
};